import React from "react";
import { injectIntl } from "react-intl";
import {
  withApi,
  apiShape,
  withBackend,
  backendShape,
  notifierShape,
  withNotifier,
} from "../../context";

import { Clue } from "../Clue";
import { SearchBar } from "../Search";
import { intlShape } from "../../shapes";
import { isTouchDevice } from "../../utils";
import { ActionBar, ActionBarButtons, CreateActionButton } from "../ActionBar";
import TicketItem from "./TicketItem";
import Loader from "../Loader";

type Props = {
  api: apiShape;
  intl: intlShape;
  backend: backendShape;
  notifier: notifierShape;
};

export function TicketSearch({ api, backend, intl, notifier }: Props) {
  const [tickets, setTickets] = React.useState();
  const [totalCount, setTotalCount] = React.useState();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const response = await backend.getAll("/support/tickets", {
        term: `${searchTerm}`,
      });
      setTotalCount(response.pagination.total_count);
      setTickets(response.tickets);
      setLoading(false);
    };
    loadData().catch((error) => {
      notifier.showError(api.translateError(error));
    });
  }, [searchTerm]);

  const onSearch = (input: $TSFixMe) => {
    setSearchTerm(input);
  };

  const badge = loading ? (
    <span className="loading">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : (
    totalCount
  );

  return (
    <div>
      <ActionBar>
        <h1>
          {intl.formatMessage({ id: "support.tickets.header" })}
          <span id="support-tickets-count" className="badge">
            {badge}
          </span>
        </h1>
        <ActionBarButtons>
          <CreateActionButton
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; }' is not assi... Remove this comment to see the full error message
            id="create-support-ticket-button"
            target="/support/tickets/create"
          />
        </ActionBarButtons>
      </ActionBar>
      <SearchBar
        // @ts-expect-error TS(2322) FIXME: Type '{ autoFocus: boolean; onSearch: (input: any)... Remove this comment to see the full error message
        autoFocus={!isTouchDevice()}
        onSearch={onSearch}
        placeholder={intl.formatMessage({ id: "label.support_ticket" })}
      />
      <ul id="support-tickets-list" className="list">
        {tickets &&
          (tickets as $TSFixMe).map((ticket: $TSFixMe) => (
            // @ts-expect-error TS(2322) FIXME: Type '{ key: any; ticket: any; }' is not assignabl... Remove this comment to see the full error message
            <TicketItem key={ticket.id} ticket={ticket} />
          ))}
        {totalCount === 0 && (
          <>
            <Clue
              details={intl.formatMessage({ id: "support.tickets.not_found" })}
            />
            <Clue
              details={intl.formatMessage({ id: "support.tickets.info" })}
            />
            <a
              href="https://addresses.endress.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: "support.tickets.service_contact" })}
            </a>
          </>
        )}
      </ul>
      {!tickets && <Loader loading />}
    </div>
  );
}

export default withBackend(withNotifier(withApi(injectIntl(TicketSearch))));
